/* eslint-disable no-console */
import { i18n } from "@lingui/core";
import axios from "axios";
import { pt } from "make-plural/plurals";

export const DEFAULT_LANGUAGE = "pt-BR";

export const getLanguageNavigator = () => {
  const language = navigator.language || navigator.userLanguage;

  return language;
}

export const getLanguage = () => {
  const enableLanguages = {
    "pt": "pt-BR", 
    "pt-BR": "pt-BR", 
    "es": "es-MX", 
    "es-MX": "es-MX",
    "en": "en",
    "en-US": "en",
  };

  const language = getLanguageNavigator();

  if (enableLanguages?.[language]) {
    return enableLanguages[language];
  }

  return DEFAULT_LANGUAGE;
}

export const LANGUAGE = getLanguage();

export const getPrivacyPolicyURL = () => {
  const privacyPolicyURLs = {
    "pt-BR": "https://olist.com/pt-br/seguranca-e-privacidade/politica-de-privacidade/",
    "es-MX": "https://olist.com/es-mx/politica-de-privacidad/",
  }

  return privacyPolicyURLs[LANGUAGE];
}

export const getOlistUrl = () => {
  const olistUrls = {
    "pt-BR": "https://olist.com",
    "es-MX": "https://olist.com/es-mx/",
  }

  return olistUrls[LANGUAGE];
}

export const getHelpUrl = () => {
  const helpUrls = {
    "pt-BR": "https://ajuda.olist.com/hc/pt-br/articles/6738235304724",
    "es-MX": "https://ayuda.olist.com/hc/es-mx",
  }

  return helpUrls[LANGUAGE];
}

i18n.loadLocaleData({ [LANGUAGE]: { plurals: pt } });

function localTranslations(language) {
  console.log("Loading local translation files");
  const lowerCaseLanguage = language.toLowerCase();
  import(`../locales/${lowerCaseLanguage}/messages`).then(({ messages }) => {
    i18n.load(lowerCaseLanguage, messages);
    i18n.activate(lowerCaseLanguage);
  });
}

if (process.env.REACT_APP_TRANSLATIONS_SERVER_APP_NAME) {
  console.log("Loading OTM translations");
  axios
    .get(
      `${process.env.REACT_APP_TRANSLATIONS_SERVER}/${process.env.REACT_APP_TRANSLATIONS_SERVER_APP_NAME}/${LANGUAGE}/translation`
    )
    .then(({ data }) => {
      console.log("OTM translations loaded");
      i18n.load(LANGUAGE.toLowerCase(), data);
      i18n.activate(LANGUAGE.toLowerCase());
    })
    .catch((error) => {
      console.log(`OTM translations load failed: ${error.message}`);
      localTranslations(LANGUAGE);
    });
} else localTranslations(LANGUAGE);

export default i18n;
